module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lxm-avatar image",
    style: ({
      width: ("" + _vm.size),
      height: ("" + _vm.size)
    })
  }, [(_vm.src) ? [_c('img', {
    attrs: {
      "src": _vm.src
    }
  })] : (_vm.name) ? [_c('div', [_vm._v("\n      " + _vm._s(_vm.name.trim().substr(0, 1)) + "\n    ")])] : (_vm.isFemale) ? [_c('img', {
    attrs: {
      "src": require("../../images/main/contact/default-female.png")
    }
  })] : [_c('img', {
    attrs: {
      "src": require("../../images/main/contact/default-male.png")
    }
  })]], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4316e2cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4316e2cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmAvatar.vue
// module id = 843
// module chunks = 0